// extracted by mini-css-extract-plugin
export default {"shell":"MainLayout_shell__L71-W"};